"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const checkStrikeShouldChange = (props) => {
    const runs = props.runsBat + props.runsExtra;
    let total = props.isDoubleScoreZone ? runs / 2 : runs;
    if (props.noBall && props.noBall.isNoBall) {
        if (props.noBall.noBallValue === undefined)
            props.noBall.noBallValue = 1;
        total -=
            props.isLastOverOfInnings && props.noBall.noBallValueLastOver !== null
                ? props.noBall.noBallValueLastOver
                : props.noBall.noBallValue;
    }
    else if (props.wide && props.wide.isWide) {
        if (props.wide.wideValue === undefined)
            props.wide.wideValue = 1;
        total -=
            props.isLastOverOfInnings && props.wide.wideValueLastOver !== null
                ? props.wide.wideValueLastOver
                : props.wide.wideValue;
    }
    if (props.isWicketAndCrossed)
        total += 1;
    return total % 2 > 0;
};
exports.default = checkStrikeShouldChange;
//# sourceMappingURL=checkStrikeShouldChange.js.map